import { useStore } from "stook";
import {
  Params as UserVehicleListParams,
  Response as UserVehicleListReponse
} from "../../../network/models/maintence/GetUserVehicleList";
import request from "../../../network/request";
import { getCurrentVehicleInfoFromApp } from "../../../utils/app";
import { formatVehiclePlate, desensitizedVin } from "../../../utils/common";

export interface ISimpleVehicle {
  label?: string;
  platenum: string;
  vin: string;
  series?: string;
  specialFlag?: number | null;
  vehicleSeriesNameCn?: string;
}
export interface IVehicle {
  label?: string;
  uid: number | null;
  vin: string;
  plateNumber: string;
  vehicleType: string;
  specialFlag: number | null;
  userType: number | null;
  vehicleSeriesNameCn?: string;
}

export default function useVehicleList() {
  const [vehicleList, setVehicleList] = useStore<IVehicle[]>("VehicleList", []);
  const [currentVehicle, setCurrentVehicle] = useStore<IVehicle | null>(
    "CurrentVehicle",
    null
  );
  const [vehicleListLoaded, setVehicleListLoaded] = useStore<boolean>(
    "vehicleListLoaded",
    false
  );

  const getUserVehicleAndList = async (
    platenumFromUrl?: string | null,
    vinFromUrl?: string | null
  ) => {
    try {
      let vehicleInfo: ISimpleVehicle = {
        label: "",
        platenum: "",
        vin: ""
      };
      let userVehicleList: IVehicle[];

      userVehicleList = await request<
        UserVehicleListParams,
        UserVehicleListReponse
      >("module/maintenance/vehicles", {});

      if (vinFromUrl !== null) {
        vehicleInfo = {
          platenum: platenumFromUrl || "",
          vin: vinFromUrl || ""
        };
      } else {
        vehicleInfo = await getCurrentVehicleInfoFromApp();
      }

      console.log("vehicleInfo >>>>>>>>>>>>>>>>>>>>>>>>>>>>", vehicleInfo);

      let formatVehicleList: IVehicle[] = [];
      let matchingVehicle: IVehicle | null = null;
      // 判断用户车辆列表是否包含当前车辆(服务端已过滤为只包含主使用人及租客的车辆)
      if (Array.isArray(userVehicleList) && userVehicleList.length > 0) {
        formatVehicleList = userVehicleList.map((vehicle) => {
          return {
            ...vehicle,
            label: vehicle.plateNumber
              ? formatVehiclePlate(vehicle.plateNumber)
              : desensitizedVin(vehicle.vin)
            // vin: vehicle.vin,
            // plateNumber: vehicle.plateNumber,
          };
        });
        // 不包含则按下面规则：
        // 1. 优先取第一辆主使用人角色的车辆为默认车辆，
        // 2. 不存在主使用人角色的车辆则默认取第一辆车
        const matchVehicle = formatVehicleList.find(
          (item) => item.vin === vehicleInfo.vin
        );
        console.log("matchVehicle >>>>>>>>>>>>>>>>>>>>>>>>>>>>", matchVehicle);

        if (!matchVehicle) {
          const ownVehicle = formatVehicleList.find(
            (item) => item.userType === 1
          );
          if (ownVehicle) {
            matchingVehicle = ownVehicle;
            vehicleInfo = {
              label: ownVehicle.plateNumber
                ? formatVehiclePlate(ownVehicle.plateNumber)
                : desensitizedVin(ownVehicle.vin),
              platenum: ownVehicle.plateNumber || "",
              vin: ownVehicle.vin || "",
              vehicleSeriesNameCn: ownVehicle?.vehicleSeriesNameCn || ""
            };
          } else {
            matchingVehicle = formatVehicleList[0];
            vehicleInfo = {
              label: formatVehicleList[0].plateNumber
                ? formatVehiclePlate(formatVehicleList[0].plateNumber)
                : desensitizedVin(formatVehicleList[0].vin),
              platenum: formatVehicleList[0].plateNumber || "",
              vin: formatVehicleList[0].vin || ""
            };
          }
        } else {
          matchingVehicle = matchVehicle;
          vehicleInfo = {
            label: matchVehicle.plateNumber
              ? formatVehiclePlate(matchVehicle.plateNumber)
              : desensitizedVin(matchVehicle.vin),
            platenum: matchVehicle.plateNumber || "",
            vin: matchVehicle.vin || ""
          };
        }
        // setSelectedVehicle();
      }

      setVehicleList(formatVehicleList);
      setCurrentVehicle(matchingVehicle);
      setVehicleListLoaded(true);
    } catch (error) {
      setVehicleListLoaded(true);
    }
  };

  return {
    vehicleList,
    vehicleListLoaded,
    setVehicleList,
    setVehicleListLoaded,
    currentVehicle,
    getUserVehicleAndList
  };
}
